module.exports = __webpack_public_path__ + "static/media/slider_arrow_right.71b26282.svg";